module.exports = __webpack_public_path__ + "img/1.789435c4.png";